import { RESET_LAYOUT, TOGGLE_NAVBAR, TOGGLE_NAVBAR_DROPDOWN } from '../actions/actionTypes';
var navbarReducer = function (state, action) {
    if (state === void 0) { state = {}; }
    switch (action.type) {
        case TOGGLE_NAVBAR:
            return {
                toggled: action.name || null
            };
        case TOGGLE_NAVBAR_DROPDOWN:
            return {
                toggled: state.toggled || null,
                openDropdown: action.name || null
            };
        case RESET_LAYOUT:
            return {};
        default:
            return state;
    }
};
export default navbarReducer;
